import styled from 'styled-components'

interface PasswordAcceptanceProps {
  isInvalid: boolean
}

export const PasswordAcceptance = styled.small<PasswordAcceptanceProps>`
  text-align: left;
  width: 100%;
  color: ${(props) => (props.isInvalid ? 'var(--error)' : 'var(--bs-body-color)')};
`

export const FormTitle = styled.p`
  font-family: 'Roboto';
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--orange-dark);
  text-align: center;
  margin-bottom: 0px;
`
